import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Usuario } from '@domain/usuario/usuario';
import { AuthDto } from '@infra/dto/auth.dto';
import { AuthMapper } from '@infra/mappers/auth.mapper';
import { AuthRepository } from '@ports/auth-repository';
import { environment } from 'environments/environment';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthHttpRepository implements AuthRepository {
  private apiUrl = `${environment.baseUrl}/seguranca`;

  constructor(private http: HttpClient) {}

  login(login: string, senha: string): Observable<Usuario> {
    return this.http
      .post<AuthDto>(`${this.apiUrl}/login`, { login, senha })
      .pipe(
        map(dto => {
          return AuthMapper.toDomain(dto);
        })
      );
  }

  logout(): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/logout`, {});
  }

  refreshToken(refreshToken: string, login: string): Observable<Usuario> {
    return this.http
      .post<AuthDto>(`${this.apiUrl}/refreshToken`, { refreshToken, login })
      .pipe(
        map(dto => {
          return AuthMapper.toDomain(dto);
        })
      );
  }
}
